/**
 * Стабильные id в теле POST при офлайн-очереди: при синке на сервер тот же id,
 * UI может сразу показывать созданную сущность.
 */

function generateUuidV4Fallback() {
  if (typeof crypto !== 'undefined') {
    if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    if (typeof crypto.getRandomValues === 'function') {
      const bytes = new Uint8Array(16);
      crypto.getRandomValues(bytes);
      bytes[6] = (bytes[6] & 0x0f) | 0x40;
      bytes[8] = (bytes[8] & 0x3f) | 0x80;
      const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
      return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
    }
  }
  const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).slice(1);
  return `${s4()}${s4()}-${s4()}-4${s4().slice(1)}-${((8 + Math.random() * 4) | 0).toString(16)}${s4().slice(1)}-${s4()}${s4()}${s4()}`;
}

const POST_PATHS_NEED_ID = new Set([
  '/clients',
  '/workouts',
  '/training-programs',
  '/trainer-locations',
  '/payments',
  '/custom-exercises',
]);

/** pathname без query, с ведущим слэшем как в axios url */
export function normalizeApiPath(url) {
  if (!url) return '';
  const s = String(url).split('?')[0];
  return s.startsWith('/') ? s : `/${s}`;
}

/**
 * Добавляет id в data для известных POST, если его ещё нет (мутирует объект).
 * @param {{ method?: string, url?: string, data?: unknown }} config
 */
export function ensurePostPayloadId(config) {
  if (!config?.data || typeof config.data !== 'object' || Array.isArray(config.data)) return;
  const m = String(config.method || 'get').toLowerCase();
  if (m !== 'post') return;
  const path = normalizeApiPath(config.url);
  const pathWithoutApiPrefix = path.replace(/^\/api\//, '/');
  if (!POST_PATHS_NEED_ID.has(path) && !POST_PATHS_NEED_ID.has(pathWithoutApiPrefix)) return;
  if (!config.data.id) {
    config.data.id = generateUuidV4Fallback();
  }
}

/**
 * Тело «успешного» ответа при постановке в офлайн-очередь (axios).
 */
export function buildOfflineQueuedResponseData(config) {
  const data = config?.data;
  const m = String(config?.method || '').toLowerCase();
  const rawPath = normalizeApiPath(config?.url);
  const path = rawPath.replace(/^\/api\//, '/');
  if (m === 'post' && data && typeof data === 'object' && !Array.isArray(data)) {
    if (path === '/workouts') {
      return {
        success: true,
        workouts: [{ ...data, queued: true, offline: true }],
        queued: true,
        offline: true,
      };
    }
    if (path === '/clients') {
      return { ...data, queued: true, offline: true };
    }
    if (path === '/payments') {
      return {
        ...data,
        queued: true,
        offline: true,
        payment_date: data.payment_date || new Date().toLocaleDateString('en-CA'),
        currency: data.currency || 'RUB',
        new_balance: null,
      };
    }
    if (path === '/training-programs') {
      return {
        id: data.id,
        trainer_id: data.trainer_id,
        name: data.name,
        description: data.description,
        message: 'Training program created successfully',
        queued: true,
        offline: true,
      };
    }
    if (path === '/trainer-locations') {
      return {
        id: data.id,
        name: data.name,
        address: data.address || null,
        is_default: !!data.is_default,
        queued: true,
        offline: true,
      };
    }
    if (path === '/custom-exercises') {
      return {
        id: data.id,
        trainer_id: data.trainer_id,
        name: data.name,
        muscle_group: data.muscle_group,
        description: data.description || null,
        created_at: new Date().toISOString(),
        queued: true,
        offline: true,
      };
    }
  }
  return { queued: true, offline: true };
}

export { generateUuidV4Fallback };
